import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { ISalesOrderHeader } from "../../declarations/SalesOrderHeader";

const searchForSalesOrderHeaders = async (
    searchTerm: string,
): Promise<ISalesOrderHeader[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<ISalesOrderHeader[]>(
        "/SalesOrderHeader/SearchForSalesOrderHeaders",
        { searchTerm },
    );
    return response.data;
};

export const useSearchForSalesOrderHeaders = (searchTerm: string) =>
    useQuery<ISalesOrderHeader[]>({
        enabled: searchTerm.length > 3,
        queryFn: () => searchForSalesOrderHeaders(searchTerm!),
        queryKey: ["SearchForSalesOrderHeaders", searchTerm],
        refetchOnWindowFocus: false,
        retry: false,
        select: (data) => data ?? [], // always return an array
    });
